import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function toRelativeTime(time: string, shortFormat?: boolean) {
  return dayjs(time).fromNow(!!shortFormat);
}
